import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'

import EquipmentDt from '@/services/dataTransferModules/equipmentDt'

import { getEquipmentTitle } from '@/helpers/entities/equipment/equipmentHelpers'
import { clearObjectServiceAttrs } from '@/helpers/utilsHelper'

export default function useEquipment(params = {}) {
	const { t: $t } = useI18n()

	const equipmentDt = new EquipmentDt()

	const postProcessEntityCallback = (equipment) => {
		return {
			...equipment,
			__ao__title: getEquipmentTitle(equipment),
		}
	}

	const {
		loadEntityFlags: flags,

		entities: fullEquipment,
		getEntities: getFullEquipment,

		extendedEntities: extendedEquipment,
		getExtendedEntities: getExtendedEquipment,

		basedEntities: basedEquipment,
		getBasedEntities: getBasedEquipment,

		hashedBasedEntities: hashedBasedEquipment,
		getHashedBasedEntities: getHashedBasedEquipment,

		createEntity: createEquipment,

		entity: equipment,
		getEntity: getEquipment,

		entityPreview: previewEquipment,
		getEntityPreview: getPreviewEquipment,

		entityPopup: popupEquipment,
		getEntityPopup: getPopupEquipment,

		patchEntity: updateEquipment,
		updateEntity: fullUpdateEquipment,
		deleteEntity: deleteEquipment,
	} = useBlProviders(
		equipmentDt,
		Object.assign(
			{
				postProcessEntityCallback,

				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Error loading equipment!'),

				showErrorNotificationForCreatingEntity: true,
				errorNotificationTextForCreatingEntity: $t('Error loading equipment!'),

				showErrorNotificationForLoadingOneEntity: true,
				errorNotificationTextForLoadingOneEntity: $t('Error loading equipment!'),

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Error loading equipment!'),

				showErrorNotificationForDeletingEntity: true,
				errorNotificationTextForDeletingEntity: $t('Error loading equipment!'),
			},
			params,
		),
	)

	const defaults = {
		creatingEquipment: {
			brand: '',
			model: '',
			property: '',
			aggregate_type: '',
		},
		fieldsToPatch: [
			'brand',
			'model',
			'property',
			'aggregate_type',
			'icon_file_id',
			'entity',
			'to_legal_entity',
			'official_number',
			'inner_number',
			'vin_number',
			'inventory_number',
			'aggregate_groups',
			'year',
			'price',
			'width',
			'aggregate_tank',
			'aggregate_tank_size',
			'photos',
			'load_capacity',
			'inventory_date',
			'inventory_executor',
		],
	}

	const copiedEquipment = ref({})

	const copyEquipment = async (equipmentId) => {
		// eslint-disable-next-line no-unused-vars
		const { id, ...equipmentToCopy } = await getEquipment(equipmentId)

		const postBody = Object.keys(defaults.creatingEquipment).reduce((body, field) => {
			body[field] = equipmentToCopy[field]
			return body
		}, {})

		const newEquipment = await createEquipment(postBody)
		const patchBody = {
			...clearObjectServiceAttrs(equipmentToCopy),
			brand: `${equipmentToCopy.brand} (${$t('copy [noun]')})`,
			photos: [],
		}

		copiedEquipment.value = await updateEquipment(newEquipment.id, patchBody)

		return copiedEquipment.value
	}

	return {
		flags,
		defaults,
		fullEquipment,
		basedEquipment,
		extendedEquipment,
		previewEquipment,
		popupEquipment,
		equipment,
		copiedEquipment,

		getBasedEquipment,
		getExtendedEquipment,
		getFullEquipment,
		getPreviewEquipment,
		getPopupEquipment,
		getEquipment,

		hashedBasedEquipment,
		getHashedBasedEquipment,

		createEquipment,
		updateEquipment,
		fullUpdateEquipment,
		deleteEquipment,
		copyEquipment,
	}
}
